import {loadNg1Module, ngmodule} from "../../bootstrap/ngmodule";
import { skillsState, skillsDashboardState, employeeSkillsItemState } from "./skills.states";
import { skillsDashboardComponent } from "./skills.dashboard.component";
import { skillsComponent } from "./skills.component";


const skillAppModule: aboTheme.INgModule = {
  components: { skillsComponent, skillsDashboardComponent },
  states: [ skillsState, skillsDashboardState, employeeSkillsItemState ],
  filters: { }
};

loadNg1Module(ngmodule, skillAppModule);


// WEBPACK FOOTER //
// ./src/app/modules/skills/index.ts